import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl, Validators } from '@angular/forms';
import { User } from '../../../../../front-user/shared/models/user.model';
import { AgentCurrencyDto, AgentCurrencyListDto } from '../../shared/models/agent-currency.model';
import { BaseRequest } from '../../../../../shared/models/base-request.model';
import { FormMode, Languages, Service } from '../../../../../shared/models/enums.model';
import { GlobalServices } from '../../../../../shared/services/global.service';
import { AlertService } from '../../../../../shared/components/alert/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationAdminService } from '../../shared/services/registration-admin.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../../../../front-user/shared/services/authentication.service';
import { BaseRequestService } from '../../../../../front-user/shipyard-service/services/base-request.service';
import { ResponseObject } from '../../../../../shared/models/response-object.model';

@Component({
  selector: 'app-activate-agent-treasury-numbers',
  templateUrl: './activate-agent-treasury-numbers.component.html',
  styleUrls: ['./activate-agent-treasury-numbers.component.css']
})
export class ActivateAgentTreasuryNumbersComponent implements OnInit {

  user: User = new User();
  offlineTreasuryNumberForm: FormGroup;
  displayedLang: string;
  baseRequestId: string ;
  submitted = false;
  loading = false; requestStatus: number;
  agentId: string;
  isErrorMessage: boolean = false;

  getAgentCurrency: AgentCurrencyDto[] = [];
  error: any = { isError: false, errorMessage: '' };
  agentCurrency: AgentCurrencyDto[] = [];
  isReadOnly = true;
  agentCurrencyList: AgentCurrencyListDto = new AgentCurrencyListDto();
  baseRequestDTO: BaseRequest;
  showRequest = false;

  public FormMode: any = FormMode;
  public formMode = FormMode.Add;
  lockTaskErrorMessage: boolean = false;
  DuplicateTreasuryNumber: boolean= false;

  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices, private alertService: AlertService,
    private route: ActivatedRoute, private adminSrv: RegistrationAdminService, private router: Router,
    private translate: TranslateService,
    private authenticationService: AuthenticationService,
    private baseRequestService: BaseRequestService, ) {

    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    // this.baseRequestId = this.route.snapshot.params.Id;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;

    }else{
      this.router.navigate(['/agentList']);
    }
    this.user = this.authenticationService.currentUserValue;

  }

  ngOnInit() {

    this.buildForm();
  }

  getBaseRequest() {
    this.baseRequestService.getByRequestorId(this.baseRequestId, Service.AgentRegisteration).subscribe(
      d => {
        if (d.Success) {
          this.baseRequestDTO = d.Data;
          this.requestStatus = this.baseRequestDTO.StatusId;
          this.agentId = this.baseRequestDTO.RequestorId;
          this.baseRequestId = this.baseRequestDTO.Id;
          this.adminSrv.getAgentCurrency(this.agentId)
            .subscribe((data: ResponseObject) => {
              this.agentCurrency = data.Data as AgentCurrencyDto[];
                this.agentCurrency = this.agentCurrency.filter(item => item.TreasuryNumber == null);
              this.bindAttachments(this.agentCurrency);
              // this.registerTreasuryNumberForm.setControl('AgentCurrencyDto', this.bindAttachments(this.agentCurrency));
            }
            );
        }
      }
    )
  }

  buildForm() {
    this.offlineTreasuryNumberForm = this.formBuilder.group({
      AgentCurrencyDto: this.formBuilder.array([]),
    });

    this.getBaseRequest();
  }


  get Currency() {
    return this.offlineTreasuryNumberForm.get('AgentCurrencyDto') as FormArray;
  }

  bindAttachments(currency): any {
    let control = <FormArray>this.offlineTreasuryNumberForm.controls['AgentCurrencyDto'];
    currency.forEach((key) => {
        if (this.globalSrv.getLanguage() == Languages.Arabic) {
          control.push(new FormGroup({
            CurrencyName: new FormControl({ value: key.Currency.NameAR, disabled: true }),
            TreasuryNumber: new FormControl('', Validators.required),
            CurrencyId: new FormControl({ value: key.CurrencyId }),
            Id: new FormControl({ value: key.Id }),
            AgentId: new FormControl({ value: key.AgentId })
          }));
        }
        if (this.globalSrv.getLanguage() == Languages.English) {
          control.push(new FormGroup({
            CurrencyName: new FormControl({ value: key.Currency.NameEN, disabled: true }),
            TreasuryNumber: new FormControl('', Validators.required),
            CurrencyId: new FormControl({ value: key.CurrencyId }),
            Id: new FormControl({ value: key.Id }),
            AgentId: new FormControl({ value: key.AgentId })
          }));
        }
     
    });
    return control;
  }


  transformCurrency(Currencies): AgentCurrencyListDto {
    Object.keys(Currencies).forEach((key) => {
      let value = Currencies[key];
      value.forEach(element => {
        element.CurrencyId = element.CurrencyId.value;
        element.AgentId = element.AgentId.value;
        element.Id = element.Id.value;
        element.TreasuryNumber = element.TreasuryNumber;
        this.agentCurrencyList.AgentCurrencyDto.push(element);
      });
    });
    return this.agentCurrencyList;
  }


  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.offlineTreasuryNumberForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;

    this.agentCurrencyList = this.transformCurrency(this.offlineTreasuryNumberForm.value);
    this.agentCurrencyList.AdminEmail = this.user.UserName;
    this.agentCurrencyList.RequestId = this.baseRequestId;
    this.agentCurrencyList.AgentId = this.agentId

    this.adminSrv.UpdateTreasuryNumbersOfflineAgents(this.agentCurrencyList)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.offlineTreasuryNumberForm.reset();
            this.showRequest = true;
            this.isErrorMessage = false;
          }   else if (data.ErrorMessages.find(e => e == "DuplicateTreasuryNumber") != null) {
            this.globalSrv.isLoaderEnabled = false;
            this.DuplicateTreasuryNumber = true;
            this.showRequest = true;
          }else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]));

          }

        });
  }


  onChangeTreasury(event, control) {

    let treasuryNumber = event.target.value;
    if (treasuryNumber) {
      this.adminSrv.CheckTreasuryNumber(treasuryNumber).subscribe((data: ResponseObject) => {
        if (!data.Success) {
          control.setErrors({ duplicatedNumber: true });
        }
        else {
          control.setErrors(null);
          control.setValidators([Validators.required]);
          control.updateValueAndValidity();
        }

      });
    }
  }
}
